import { validateInput, isCharAllowed } from '@/utils/validation';

export default {
  bind(el, binding) {
    const inputType = binding.arg || 'id'; // 'id' ou 'password'

    // Contrôle en temps réel pendant la saisie
    el.addEventListener('input', (e) => {
      const { value } = e.target;
      const validation = validateInput(value, inputType);

      if (!validation.isValid) {
        // Ajouter classe d'erreur
        el.classList.add('is-invalid');

        // Afficher message d'erreur
        let errorDiv = el.parentNode.querySelector('.char-validation-error');
        if (!errorDiv) {
          errorDiv = document.createElement('div');
          errorDiv.className = 'char-validation-error text-danger small mt-1';
          el.parentNode.appendChild(errorDiv);
        }
        errorDiv.textContent = validation.message;
      } else {
        el.classList.remove('is-invalid');
        const errorDiv = el.parentNode.querySelector('.char-validation-error');
        if (errorDiv) {
          errorDiv.remove();
        }
      }
    });

    // Prévenir la saisie de caractères interdits
    el.addEventListener('keypress', (e) => {
      const char = String.fromCharCode(e.which);

      if (!isCharAllowed(char, inputType)) {
        e.preventDefault();

        // Afficher temporairement un message d'avertissement
        let warningDiv = el.parentNode.querySelector('.char-warning');
        if (!warningDiv) {
          warningDiv = document.createElement('div');
          warningDiv.className = 'char-warning text-warning small mt-1';
          el.parentNode.appendChild(warningDiv);
        }

        if (inputType === 'id') {
          warningDiv.textContent = 'Caractère non autorisé. Utilisez uniquement : lettres, chiffres, points (.), tirets (-) et underscores (_)';
        } else {
          warningDiv.textContent = 'Caractère non autorisé. Utilisez uniquement : lettres, chiffres et caractères spéciaux (! @ # $ % * - _)';
        }

        // Supprimer le message après 3 secondes
        setTimeout(() => {
          if (warningDiv && warningDiv.parentNode) {
            warningDiv.remove();
          }
        }, 3000);
      }
    });

    // Nettoyer au paste
    el.addEventListener('paste', (e) => {
      setTimeout(() => {
        const { value } = e.target;
        const validation = validateInput(value, inputType);

        if (!validation.isValid) {
          // Déclencher l'événement input pour la validation
          const inputEvent = new Event('input', { bubbles: true });
          el.dispatchEvent(inputEvent);
        }
      }, 0);
    });
  },
};
